import React from 'react';
import CheckboxBase, { ICheckboxCommonProps } from './base/CheckboxBase';

interface ICheckboxProps extends ICheckboxCommonProps {
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    value?: boolean;
}

const Checkbox: React.FC<ICheckboxProps> = (props) => {
    return <CheckboxBase {...props} />;
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/controls/forms/Checkbox.tsx